import { render } from "./edit.vue?vue&type=template&id=171b7f2e&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=171b7f2e&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171b7f2e"],['__file',"src/views/food/desk/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "171b7f2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('171b7f2e', __exports__)) {
    console.log('reload')
    api.reload('171b7f2e', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=171b7f2e&scoped=true", () => {
    console.log('re-render')
    api.rerender('171b7f2e', render)
  })

}


export default __exports__